import { render, staticRenderFns } from "./OpcoesSolicAtualizCad.vue?vue&type=template&id=139d6ec6&"
import script from "./OpcoesSolicAtualizCad.vue?vue&type=script&lang=js&"
export * from "./OpcoesSolicAtualizCad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports